import React from 'react';
import {makeStyles, withStyles, Typography, Grid, Button, Paper, Divider} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import customAxios from "../../../../API/customAxios";
import {postEditEmployeeAllowance} from "../../api/review";
import {adminDialogStyle, breakpoints, reviewStyle} from '../../../../UIComponent/CommonStyle'
import SummaryItem from "./SummaryItem";

const useStyles = makeStyles((theme) => ({
    ...adminDialogStyle(theme),
    ...reviewStyle(theme),
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: '5px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(1, 2, 1),
        width: '60%',
        [breakpoints.up("md")]: {
            padding: theme.spacing(2, 4, 3),
        }
    },
    loadingBar: {
        width: '99%',
        marginLeft: '3px',
    }
}));

export default function Review(
    {
        handleClose,
        backToTable,
        open,
        showId,
        employeeName,
        values,
        updateAllowance,
    }
) {

    const [showAfterSubmit, setShowAfterSubmit] = React.useState(false);
    const [isError, setError] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [dbValues, setDBValues] = React.useState({})
    const [showCompetent, setShowCompetent] = React.useState(false);

    const classes = useStyles();

    const StyledDivider = withStyles({
        root: {
            background: '#DCDCDC',
            marginTop: 1,
            marginBottom: 1,
            height: 1,
        },
    })(Divider);

    const handleCancel = (event, reason) => {
        if (reason !== 'backdropClick') {
            handleClose();
        }
    };

    React.useEffect(() => {
        customAxios.get(`/get_employee_allowance/` + showId)
            .then(res => {
                setDBValues(res.data);
                setShowCompetent(true);
            })
    }, []);

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        setIsLoading(true);
        try {
            await postEditEmployeeAllowance(showId, values);
            updateAllowance();
            handleClose();
            backToTable();
        } catch (e) {
            setShowCompetent(false);
            setShowAfterSubmit(true);
            setIsLoading(false);
            setError(true);
            window.setTimeout((() => {
                setShowAfterSubmit(false);
                handleClose();
            }), 3000);
        }
    };

    return (
        <React.Fragment>
            <Modal
                disableScrollLock
                aria-labelledby="confirmation-modal-title"
                aria-describedby="confirmation-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleCancel}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <>
                        {showCompetent ?
                            <Paper className={classes.modalPaper}>
                                <Typography variant="h6" color="primary" className={classes.title}>
                                    Edit Summary - {employeeName}
                                </Typography>
                                <StyledDivider/>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography className={classes.subtitle}>Please confirm the below
                                            information</Typography>
                                    </Grid>
                                    {values.annual_allowances.map(function (annualAllowance, i) {
                                        return (
                                            <React.Fragment key={i}>
                                                <Grid item xs={12}>
                                                    <Typography
                                                        className={classes.colorSubtitle}>{annualAllowance.year} Annual
                                                        Leave</Typography>
                                                </Grid>
                                                <SummaryItem title={'Entitled'}
                                                             dbValue={dbValues.annual_allowances[i].total}
                                                             updatedValue={annualAllowance.total}/>
                                                <SummaryItem title={'Taken'}
                                                             dbValue={dbValues.annual_allowances[i].taken}
                                                             updatedValue={annualAllowance.taken}/>
                                                <SummaryItem title={'SH AL Entitled'}
                                                             dbValue={dbValues.annual_allowances[i].gov_leave_total}
                                                             updatedValue={annualAllowance.gov_leave_total}/>
                                                <SummaryItem title={'SH AL Balance'}
                                                             dbValue={dbValues.annual_allowances[i].gov_leave_balance}
                                                             updatedValue={annualAllowance.gov_leave_balance}/>
                                                <SummaryItem title={'Full Year Entitlement'}
                                                             dbValue={dbValues.annual_allowances[i].yearly_entitlement}
                                                             updatedValue={annualAllowance.yearly_entitlement}/>
                                                <SummaryItem title={'Expiry Date'}
                                                             dbValue={dbValues.annual_allowances[i].expiry_date}
                                                             updatedValue={annualAllowance.expiry_date}/>
                                                <Grid item xs={12} style={{padding: 0}}>
                                                    <StyledDivider/>
                                                </Grid>
                                            </React.Fragment>
                                        )
                                    })}
                                    <Grid item xs={12}>
                                        <Typography
                                            className={classes.colorSubtitle}>Sick Leave</Typography>
                                    </Grid>
                                    <SummaryItem title={'Entitled'} dbValue={dbValues.sick_allowances.total}
                                                 updatedValue={values.sick_allowances.total}/>
                                    <SummaryItem title={'Taken'} dbValue={dbValues.sick_allowances.taken}
                                                 updatedValue={values.sick_allowances.taken}/>
                                    <Grid item xs={12}>
                                        <div className={classes.buttonDiv}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                onClick={handleSubmit}
                                                disabled={isLoading}
                                                className={classes.submitButton}
                                            >
                                                Confirm
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="secondary"
                                                onClick={handleCancel}
                                                disabled={isLoading}
                                                className={classes.submitButton}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Paper>
                            :
                            <div/>
                        }
                        {showAfterSubmit &&
                        <Paper className={classes.afterSubmitPage}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {!isError ? <Typography className={classes.title}>Edit Successful</Typography> :
                                        <Typography className={classes.title}>An error occurred, please try again
                                            later.</Typography>}
                                </Grid>
                                <Grid item xs={12}>
                                    {!isError ? <CheckCircleIcon style={{fontSize: '100px', color: 'green'}}/> :
                                        <CancelIcon color="secondary" style={{fontSize: '100px'}}/>}
                                </Grid>
                            </Grid>
                        </Paper>
                        }
                    </>
                </Fade>
            </Modal>
        </React.Fragment>
    );
}
